import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
//import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { ILoginForm } from 'src/app/auth/forms/login-form/login-form.component';
import { AuthService } from 'src/app/auth/services/auth.service';
import { PageService } from 'src/app/services/page.service';
import { ModalDisplayComponent } from 'src/app/shared/components/modal-display/modal-display.component';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
    templateUrl: './proceed-as-guest-modal.component.html',
    styleUrls: ['./proceed-as-guest-modal.component.scss'],
    standalone: false
})
export class ProceedAsGuestModalComponent implements OnInit {
  title: string = 'Nav.Checkout';
  state: string = null;

  logo!: SafeUrl;

  constructor(private authService: AuthService,
    private loader: LoaderService,
    private modalCtrl: ModalController,
    private router: Router,
    private pageService: PageService,
    public setting: SettingService,
    //private translate: TranslateService
    private translationService: TranslationService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    //this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.apiUrl("/Menu/GetMenuItemImage?name=" + this.setting.configuration.logoShortName));
    if(this.setting.configuration?.logoShortName) {
      this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.apiUrl("/Menu/GetMenuItemImage?name=" + this.setting.configuration.logoShortName));
    } else if(this.setting.configuration?.logoUrl) {
      this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.configuration?.logoUrl);
    } else {
      this.logo = this.sanitizer.bypassSecurityTrustUrl(null);
    }
    //this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.apiUrl("/Menu/GetMenuItemImage?name=" + this.setting.configuration.logoShortName));
  }
  
  get privacyPolicyUrl() {
    return this.setting.getSeeMyPassUrl(`${this.translationService.getLanguage()}/privacy`);
  }

  public static async open(modalCtrl: ModalController) {
    const modal = await modalCtrl.create({
      component: ProceedAsGuestModalComponent,
    });
    await modal.present();
    return modal;
  }

  async onFormSubmited(form: ILoginForm) {
    const loader = await this.loader.create();
    this.authService.login({
      Email: form.email,
      Password: form.password
    })
    .pipe(finalize(async () => {
      await loader.dismiss();
    }))
    .subscribe(() => {
     this.modalCtrl.dismiss({cancelCart: false});
    }, (error) => {
      this.authService.showLoginError(error);
    });
  }

  continueAsGuest() {
    this.modalCtrl.dismiss({cancelCart: false});
  }

  onLogin() {
    this.modalCtrl.dismiss({
      cancelCart: false
    });
  }

  onForgotPasswordClicked() {
    this.modalCtrl.dismiss({
      cancelCart: true
    });
  }

  onLoginAllinOne() {
    this.modalCtrl.dismiss({
      cancelCart: false
    });
  }
  
  notLoginAllinOne() {
    this.modalCtrl.dismiss({
      cancelCart: true
    });
  }

  goToLogin() {
   // this.router.navigateByUrl('/auth/login');
   this.state = 'login';
  }

  goToRegister() {
    this.modalCtrl.dismiss({
      cancelCart: true
    });
    this.router.navigateByUrl('/auth/register');
  }

  goToForgotPassword() {
    this.modalCtrl.dismiss({
      cancelCart: true
    });
    this.router.navigateByUrl('/auth/forgot-password');
  }

  back() {
    if (this.state == null) {
      //Pressing back to dismiss the modal
      this.modalCtrl.dismiss({
        cancelCart: true
      });
    }
    this.state = null;
  }

  async termsOfUse() {
    const loader = await this.loader.create();
    this.pageService
      .getTerms()
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(async (result) => {
        const requestModal = await this.modalCtrl.create({
          component: ModalDisplayComponent,
          componentProps: {
            title: "General.Terms",
            content: result
          }
        });

        await requestModal.present();
      });
  }

  isLoeufrierLogo() {
    return this.setting.getMerchantId() == '60562f915c4b23000133c87b';
  }
}
